// Super Admin Organization Endpoints
export const SA_ORG_REGISTRATION = "/authentication/sa-org-registration";
export const SA_ORGANIZATIONS_LIST = "/authentication/super-admin/organizations";
export const SA_ORGANIZATIONS_EXPORT = "/super-admin/organizations/export";
export const SA_ORG_PROFILE = (orgId: string) => `/sa-organizations/${orgId}`;
export const SA_ORG_UPDATE = (orgId: string) => `/authentication/sa-organizations/${orgId}/update`;
export const SA_ORG_DEACTIVATE = (orgId: string) => `/sa-organizations/${orgId}/deactivate`;

// Super Admin User Endpoints
export const SA_USER_PROFILE = "/authentication/sa-user-profile";
export const SA_USER_SIGNOUT = "/secure-auth/logout";

// Authentication Endpoints
export const LOGIN_ENDPOINT = "/secure-auth/login"; 
export const RESEND_PASSWORD="authentication/forgot-password ";
export const RESET="/authentication/reset-password";

// Masterfile Endpoints
export const MASTER_CONTROLS_UPLOAD = "/masterconfig/controls-upload";
export const MASTER_PARAMS_UPLOAD = "/masterconfig/params-upload";
export const MASTER_HELPER_UPDATE = "/securityscan/master-helper-update";
export const MASTER_CONTROLS_DATA = "/securityscan/controls-data";
export const MASTER_DATA = "/securityscan/master-data";

// Masterconfig (via VITE_MASTERCONFIG_BASE_URL or VITE_SUPERADMIN_BASE_URL)
export const MC_VERSION = "/masterconfig/version";
export const MC_CONTROLS_UPLOAD = "/masterconfig/controls-upload";
export const MC_PARAMS_UPLOAD = "/masterconfig/params-upload";

// Permission Endpoints
export const SA_CREATE_PERMISSION = "/authentication/create-permission";
export const SA_PERMISSIONS_LIST = "/authentication/get-permissions";
export const SA_GET_PARENT_PERMISSIONS = "/authentication/get-parent-permissions";

